import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useReselector } from '@/utils/sharedHooks'
import { useIsDeviceWidth, DeviceWidthCombo } from '@/utils/deviceWidthHelpers'
import { selectPanelOpen } from '@/features/adviser-chat/adviser-chat.selectors'
import {
  havenFullScreenPath,
  isHavenPath,
  readHavenReturnTo,
  withoutLaunchParams,
  type HavenRouteState,
} from '@/features/adviser-chat/lib/havenRoutes'
import { withViewTransition } from '@/features/adviser-chat/components/panelAnimations'

/** Opens full-screen Haven, remembering the current page so Exit full screen and close can return to it. */
export const useOpenHavenFullScreen = () => {
  const navigate = useNavigate()
  const { pathname, search, state } = useLocation()
  const panelOpen = useReselector(selectPanelOpen)
  const isMobile = useIsDeviceWidth(DeviceWidthCombo.mobileOrTablet)

  return useCallback(
    (conversationId?: number | null, havenSearch = '') => {
      const havenReturnTo = isHavenPath(pathname)
        ? readHavenReturnTo(state)
        : `${pathname}${withoutLaunchParams(search)}`
      const routeState: HavenRouteState = havenReturnTo ? { havenReturnTo } : {}
      // On mobile /haven draws the panel's chat, where no rail is mounted to take the view.
      const target = `${havenFullScreenPath(conversationId)}${isMobile ? '' : havenSearch}`
      const open = () => navigate(target, { state: routeState })
      // Morph only from an open panel: a view transition delays the navigation, so a redirect can land after it.
      if (panelOpen) withViewTransition(open)
      else open()
    },
    [isMobile, navigate, pathname, search, state, panelOpen]
  )
}
